module.exports = __webpack_public_path__ + "media/images/logos/vuejs-8a62d8d78e44a6067016b6ff32d9f942.svg";